import { Link } from "react-router-dom";

export const AppFooter = ({ className = "" }) => (
  <footer
    className={`flex h-9 shrink-0 items-center justify-center gap-4 border-t bg-background px-4 ${className}`}
    data-testid="app-footer"
  >
    <Link
      className="text-xs text-muted-foreground transition-colors hover:text-primary hover:underline"
      to="/privacy"
      data-testid="footer-privacy-link"
    >
      Privacy policy
    </Link>
    <Link
      className="text-xs text-muted-foreground transition-colors hover:text-primary hover:underline"
      to="/faq"
      data-testid="footer-faq-link"
    >
      FAQ
    </Link>
  </footer>
);